import modalStyle from "assets/jss/material-dashboard-pro-react/modalStyle.js";


const termsAndConditionsDialogStyle = (theme) => ({
  mainDiv: {
    padding: "0px",
  }
})

export default termsAndConditionsDialogStyle;